import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { Outlet, useRoutes } from "react-router-dom";
import { MantineProvider,createTheme } from '@mantine/core';


import useCustomQueryClient from "@/hooks/useCustomQueryClient";

import AppLayout from "@/layouts/app-layout";

import AuthRoutes from "@/features/auth/auth-routes";
import DashboardRoutes from "@/features/dashboard/dashboard-routes";
import  ApplicationRoutes from "@/features/applications/application-routes";



import NotFound from "@/features/errors/not-found";
import InspectionRoutes from "@/features/Inspections/inspection-routes.tsx";
import ComplaintRoutes from "@/features/applications/complaints/complaint-routes.tsx";
import LicenceRoutes from "@/features/licence/licence-routes.tsx";
import SettingsRoutes from "@/features/settings/settings-routes.tsx";

import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';

const theme = createTheme({})

const AppRoutes = () => {
    return useRoutes([
        AuthRoutes,
        {
            path: "/",
            element: <AppLayout />,
            children: [
                DashboardRoutes,
                ApplicationRoutes,
                InspectionRoutes,
                ComplaintRoutes,
                LicenceRoutes,
                SettingsRoutes 
                
            ]
        },
        {
            path: "*",
            element: <NotFound />
        },
    ]);
};


export default function App() {
    const client = useCustomQueryClient();

    return (
        <main className="font-inter">
            <QueryClientProvider client={client}>
               <MantineProvider theme={theme} defaultColorScheme="light">
                    <Toaster position="top-right" reverseOrder={false} />
                    <AppRoutes />
                    <Outlet />
                </MantineProvider>
            </QueryClientProvider>
        </main>
    )
}